// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!./nav.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js!./sidebar.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../node_modules/css-loader/dist/cjs.js!./summary.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../../node_modules/css-loader/dist/cjs.js!./extras.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#reticle {
    color: #F2893A; 
    position: absolute;
    top: 50%; 
    left: 50%;
}

:root {
    --background: #45535F;
    --background-light: #274861;
    --background-dark: #2E3B46;
    --darkText: white;
    --background-highlight: white;
    --lightText: #323232;

    --highlight: white; 

}

body {
    max-height: 100vh;
    overflow-y: hidden;
}

a {
    color: var(--darkText);
}

.esri-widget--button {
    background-color: var(--calcite-color-foreground-3);
}


.customWidget {
    padding: calc(var(--esri-widget-padding-y)* .5) calc(var(--esri-widget-padding-x)* .5);
}

.dynamicElem {
    transition:  0.40s
}

.hiddenElem, div.hiddenElem {
    visibility: hidden; 
    opacity: 0;
    max-height: 0;
    margin: 0;
    padding: 0!important;
}

.unhiddenElem {
    visibility: visible;
    max-height: 9999px;
    opacity: 1;

}

.esri-expand__content--expanded, .esri-expand__popover-content {
    overflow-y: auto;
    max-height: 80vh; 
}

.esri-sketch__tool-section.esri-sketch__section {
    padding: 0;
    margin-top: 0;
}

/*.esri-widget {
    background-color: var(--background-light); 
    color: var(--darkText);
}*/
/*
.esri-widget--button {
    background-color: var(--background-light);
    color: var(--darkText);
}
*/
/*
.esri-widget__heading {
    color: white;
}

.esri-basemap-gallery {
    background-color: var(--background-dark);
    color: var(--darkText);
}

.esri-basemap-gallery__item--selected {
    background-color: var(--background-highlight) !important; 
    color: var(--darkText) !important;
}

.esri-basemap-gallery__item {
    background-color: var(--background);
}


.esri-basemap-gallery {
    background-color: var(--background-dark);
    color: var(--darkText);
}


.esri-basemap-gallery__item-title {
    color: var(--darkText); 
}

.esri-feature-content, .esri-feature-content div {
    color: white !important;
}
*/
.esri-selection-toolbar {
    background-color: var(--calcite-color-background);
}

@media only screen and (max-width: 768px) {
.esri-features__container {
    padding: 2px !important;
}
}

article > footer {
    order: -100;
}

hr {
    border: none; 
    color: white; 
    background-color: white; 
}

html,
body {
    padding-top: 0;
    margin: 0;
    height: 100%;
    width: 100%;
    color: var(--calcite-color-text-1);
    display: flex; 
    align-items: stretch; 
    flex-direction: column;
    max-height: 100vh; 
}

.mapContainer {
    display: flex;
    align-items: stretch; 
    height: 100%; 
    overflow: hidden;
}












.idNotice {
    margin-top: 10px;
    margin-bottom: 16px;
}

calcite-action button {
    background-color: black !important;
}

.nav-item .nav-link {
    border-radius: 0;
    color: white;  
}

.nav-tabs {
    border: 0;
    background-color: var(--highlightEm);
}

.nav-tabs .nav-link.active {
    background-color: var(--highlight);
    color: var(--calcite-color-text-inverse);
}

hr.tabHr {
    padding: 0;
    margin: 0;
    color: white !important;
    height: 1px;
    opacity: 1;
 
    
   

}
   
#AdSearchResults {
    padding-top: 2em;
}

calcite-button {
    margin-bottom: 6px;
}

calcite-label calcite-input {
    margin-bottom: 0;
}

#viewDiv {
    float: left;

      margin: 0;
      height: 100%;
      width: 100%;
      transition: .8s;
   }

   #sidebar {
    margin-left: -20%;
    transition: all 0.8s, background-color 0s;
      float: left;
      width: 20%;
        
    display: flex;
    flex-direction: column;
    scrollbar-color: black;
      

    max-height: 100%;
  background-color: var(--calcite-color-background);
 
  font-size:13px;

    
}

   #sidebarContainer {
        padding: 1em; 

   }


   
.calcite-mode-dark #sidebar a {
    color: #b2dbff;
}

.calcite-mode-dark #sidebar {
    scrollbar-color: var(--calcite-color-text-2) var(--calcite-color-border-1);
}



.esri-editor .esri-item-list__scroller {
  max-height: 350px;
}

.tab-content button, .tab-content input[type = "button"]{
    background-color: #45535F;
    border: none;
    color: white;
    padding: 10px;
}

table {
    border-collapse: separate;
    text-indent: initial;
    line-height: normal;
    font-weight: normal;
    font-size: medium;
    font-style: normal;
    color: -internal-quirk-inherit;
    text-align: start;
    border-spacing: 2px;
    white-space: normal;
    font-variant: normal;
}

#summaryModalContent table, table.summaryTable {
    width:100%; 
}

#summaryModalContent a {
    width: 100%;

}
.calcite-mode-dark #summaryModalContent a {
    color: rgb(182, 211, 254);
}

calcite-modal h1, calcite-modal h2, calcite-modal h3, calcite-modal h4 calcite-modal h5
{
    color: var(--calcite-color-text-inverse);
}

calcite-modal h1 {
    font-size: 1.4em; 
    font-weight: 400;
}

#summaryModalContent h2 {
    font-size: 1.4em;
    border-bottom: 2px solid white;
    padding: 5px;
    background-color: #2E3B46;
    margin-bottom: 10px;
}

#summaryModalContent h3 {
    font-size: 1.2em;
    margin-top: 20px;
    padding: 5px;
    background-color: #2E3B46;
    margin-bottom: 10px;
    border-bottom: 1px solid white;
}

#summaryModalContent > div:nth-child(1) > h2{
    margin-top: 0;
}

#summaryModalContent p {
    margin-top: 10px;
}
#summaryModalContent hr {
    padding: 0;
    margin: 0;
}

#summaryMap, #mapCol, #summaryImage {
    aspect-ratio: 1/1; 
}

calcite-input, .esri-input {
    margin-bottom: 10px;
}

.propertySearchDiv {
    width: 400px;
}`, "",{"version":3,"sources":["webpack://./src/css/BrandNewMaps.css"],"names":[],"mappings":"AAGA;IACI,cAAc;IACd,kBAAkB;IAClB,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,qBAAqB;IACrB,2BAA2B;IAC3B,0BAA0B;IAC1B,iBAAiB;IACjB,6BAA6B;IAC7B,oBAAoB;;IAEpB,kBAAkB;;AAEtB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,mDAAmD;AACvD;;;AAGA;IACI,sFAAsF;AAC1F;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,SAAS;IACT,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;;AAEd;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,aAAa;AACjB;;AAEA;;;EAGE;AACF;;;;;CAKC;AACD;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAiCC;AACD;IACI,iDAAiD;AACrD;;AAEA;AACA;IACI,uBAAuB;AAC3B;AACA;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;;IAEI,cAAc;IACd,SAAS;IACT,YAAY;IACZ,WAAW;IACX,kCAAkC;IAClC,aAAa;IACb,oBAAoB;IACpB,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,YAAY;IACZ,gBAAgB;AACpB;;;;;;;;;;;;;AAaA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,oCAAoC;AACxC;;AAEA;IACI,kCAAkC;IAClC,wCAAwC;AAC5C;;AAEA;IACI,UAAU;IACV,SAAS;IACT,uBAAuB;IACvB,WAAW;IACX,UAAU;;;;;AAKd;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;;MAET,SAAS;MACT,YAAY;MACZ,WAAW;MACX,eAAe;GAClB;;GAEA;IACC,iBAAiB;IACjB,yCAAyC;MACvC,WAAW;MACX,UAAU;;IAEZ,aAAa;IACb,sBAAsB;IACtB,sBAAsB;;;IAGtB,gBAAgB;EAClB,iDAAiD;;EAEjD,cAAc;;;AAGhB;;GAEG;QACK,YAAY;;GAEjB;;;;AAIH;IACI,cAAc;AAClB;;AAEA;IACI,0EAA0E;AAC9E;;;;AAIA;EACE,iBAAiB;AACnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,8BAA8B;IAC9B,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;;AAEf;AACA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,wCAAwC;AAC5C;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,8BAA8B;IAC9B,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,UAAU;IACV,SAAS;AACb;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAKA;IACI,YAAY;AAChB","sourcesContent":["@import url(./nav.css);\r\n@import url(./sidebar.css);\r\n\r\n#reticle {\r\n    color: #F2893A; \r\n    position: absolute;\r\n    top: 50%; \r\n    left: 50%;\r\n}\r\n\r\n:root {\r\n    --background: #45535F;\r\n    --background-light: #274861;\r\n    --background-dark: #2E3B46;\r\n    --darkText: white;\r\n    --background-highlight: white;\r\n    --lightText: #323232;\r\n\r\n    --highlight: white; \r\n\r\n}\r\n\r\nbody {\r\n    max-height: 100vh;\r\n    overflow-y: hidden;\r\n}\r\n\r\na {\r\n    color: var(--darkText);\r\n}\r\n\r\n.esri-widget--button {\r\n    background-color: var(--calcite-color-foreground-3);\r\n}\r\n\r\n\r\n.customWidget {\r\n    padding: calc(var(--esri-widget-padding-y)* .5) calc(var(--esri-widget-padding-x)* .5);\r\n}\r\n\r\n.dynamicElem {\r\n    transition:  0.40s\r\n}\r\n\r\n.hiddenElem, div.hiddenElem {\r\n    visibility: hidden; \r\n    opacity: 0;\r\n    max-height: 0;\r\n    margin: 0;\r\n    padding: 0!important;\r\n}\r\n\r\n.unhiddenElem {\r\n    visibility: visible;\r\n    max-height: 9999px;\r\n    opacity: 1;\r\n\r\n}\r\n\r\n.esri-expand__content--expanded, .esri-expand__popover-content {\r\n    overflow-y: auto;\r\n    max-height: 80vh; \r\n}\r\n\r\n.esri-sketch__tool-section.esri-sketch__section {\r\n    padding: 0;\r\n    margin-top: 0;\r\n}\r\n\r\n/*.esri-widget {\r\n    background-color: var(--background-light); \r\n    color: var(--darkText);\r\n}*/\r\n/*\r\n.esri-widget--button {\r\n    background-color: var(--background-light);\r\n    color: var(--darkText);\r\n}\r\n*/\r\n/*\r\n.esri-widget__heading {\r\n    color: white;\r\n}\r\n\r\n.esri-basemap-gallery {\r\n    background-color: var(--background-dark);\r\n    color: var(--darkText);\r\n}\r\n\r\n.esri-basemap-gallery__item--selected {\r\n    background-color: var(--background-highlight) !important; \r\n    color: var(--darkText) !important;\r\n}\r\n\r\n.esri-basemap-gallery__item {\r\n    background-color: var(--background);\r\n}\r\n\r\n\r\n.esri-basemap-gallery {\r\n    background-color: var(--background-dark);\r\n    color: var(--darkText);\r\n}\r\n\r\n\r\n.esri-basemap-gallery__item-title {\r\n    color: var(--darkText); \r\n}\r\n\r\n.esri-feature-content, .esri-feature-content div {\r\n    color: white !important;\r\n}\r\n*/\r\n.esri-selection-toolbar {\r\n    background-color: var(--calcite-color-background);\r\n}\r\n\r\n@media only screen and (max-width: 768px) {\r\n.esri-features__container {\r\n    padding: 2px !important;\r\n}\r\n}\r\n\r\narticle > footer {\r\n    order: -100;\r\n}\r\n\r\nhr {\r\n    border: none; \r\n    color: white; \r\n    background-color: white; \r\n}\r\n\r\nhtml,\r\nbody {\r\n    padding-top: 0;\r\n    margin: 0;\r\n    height: 100%;\r\n    width: 100%;\r\n    color: var(--calcite-color-text-1);\r\n    display: flex; \r\n    align-items: stretch; \r\n    flex-direction: column;\r\n    max-height: 100vh; \r\n}\r\n\r\n.mapContainer {\r\n    display: flex;\r\n    align-items: stretch; \r\n    height: 100%; \r\n    overflow: hidden;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n.idNotice {\r\n    margin-top: 10px;\r\n    margin-bottom: 16px;\r\n}\r\n\r\ncalcite-action button {\r\n    background-color: black !important;\r\n}\r\n\r\n.nav-item .nav-link {\r\n    border-radius: 0;\r\n    color: white;  \r\n}\r\n\r\n.nav-tabs {\r\n    border: 0;\r\n    background-color: var(--highlightEm);\r\n}\r\n\r\n.nav-tabs .nav-link.active {\r\n    background-color: var(--highlight);\r\n    color: var(--calcite-color-text-inverse);\r\n}\r\n\r\nhr.tabHr {\r\n    padding: 0;\r\n    margin: 0;\r\n    color: white !important;\r\n    height: 1px;\r\n    opacity: 1;\r\n \r\n    \r\n   \r\n\r\n}\r\n   \r\n#AdSearchResults {\r\n    padding-top: 2em;\r\n}\r\n\r\ncalcite-button {\r\n    margin-bottom: 6px;\r\n}\r\n\r\ncalcite-label calcite-input {\r\n    margin-bottom: 0;\r\n}\r\n\r\n#viewDiv {\r\n    float: left;\r\n\r\n      margin: 0;\r\n      height: 100%;\r\n      width: 100%;\r\n      transition: .8s;\r\n   }\r\n\r\n   #sidebar {\r\n    margin-left: -20%;\r\n    transition: all 0.8s, background-color 0s;\r\n      float: left;\r\n      width: 20%;\r\n        \r\n    display: flex;\r\n    flex-direction: column;\r\n    scrollbar-color: black;\r\n      \r\n\r\n    max-height: 100%;\r\n  background-color: var(--calcite-color-background);\r\n \r\n  font-size:13px;\r\n\r\n    \r\n}\r\n\r\n   #sidebarContainer {\r\n        padding: 1em; \r\n\r\n   }\r\n\r\n\r\n   \r\n.calcite-mode-dark #sidebar a {\r\n    color: #b2dbff;\r\n}\r\n\r\n.calcite-mode-dark #sidebar {\r\n    scrollbar-color: var(--calcite-color-text-2) var(--calcite-color-border-1);\r\n}\r\n\r\n\r\n\r\n.esri-editor .esri-item-list__scroller {\r\n  max-height: 350px;\r\n}\r\n\r\n.tab-content button, .tab-content input[type = \"button\"]{\r\n    background-color: #45535F;\r\n    border: none;\r\n    color: white;\r\n    padding: 10px;\r\n}\r\n\r\ntable {\r\n    border-collapse: separate;\r\n    text-indent: initial;\r\n    line-height: normal;\r\n    font-weight: normal;\r\n    font-size: medium;\r\n    font-style: normal;\r\n    color: -internal-quirk-inherit;\r\n    text-align: start;\r\n    border-spacing: 2px;\r\n    white-space: normal;\r\n    font-variant: normal;\r\n}\r\n\r\n#summaryModalContent table, table.summaryTable {\r\n    width:100%; \r\n}\r\n\r\n#summaryModalContent a {\r\n    width: 100%;\r\n\r\n}\r\n.calcite-mode-dark #summaryModalContent a {\r\n    color: rgb(182, 211, 254);\r\n}\r\n\r\ncalcite-modal h1, calcite-modal h2, calcite-modal h3, calcite-modal h4 calcite-modal h5\r\n{\r\n    color: var(--calcite-color-text-inverse);\r\n}\r\n\r\ncalcite-modal h1 {\r\n    font-size: 1.4em; \r\n    font-weight: 400;\r\n}\r\n\r\n#summaryModalContent h2 {\r\n    font-size: 1.4em;\r\n    border-bottom: 2px solid white;\r\n    padding: 5px;\r\n    background-color: #2E3B46;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n#summaryModalContent h3 {\r\n    font-size: 1.2em;\r\n    margin-top: 20px;\r\n    padding: 5px;\r\n    background-color: #2E3B46;\r\n    margin-bottom: 10px;\r\n    border-bottom: 1px solid white;\r\n}\r\n\r\n#summaryModalContent > div:nth-child(1) > h2{\r\n    margin-top: 0;\r\n}\r\n\r\n#summaryModalContent p {\r\n    margin-top: 10px;\r\n}\r\n#summaryModalContent hr {\r\n    padding: 0;\r\n    margin: 0;\r\n}\r\n\r\n#summaryMap, #mapCol, #summaryImage {\r\n    aspect-ratio: 1/1; \r\n}\r\n\r\ncalcite-input, .esri-input {\r\n    margin-bottom: 10px;\r\n}\r\n\r\n@import url(summary.css);\r\n@import url(extras.css);\r\n\r\n.propertySearchDiv {\r\n    width: 400px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
